<div class="removal-panel">
  <div class="panel-text">
    {{title | translate}}
    <span> {{(subTitle || "COMMUNICATIONS.RemovalPanel_Selected") | translate}}</span>
  </div>
  <ng-content></ng-content>
  <ion-button (click)="remove()" *ngIf="removeButtonTitle" class="page-button"
              color="danger">{{ removeButtonTitle || 'COMMUNICATIONS.RemovalPanel_Delete_Selected' | translate }}</ion-button>
</div>
